var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenTick3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0558 13.3268C29.6644 16.3139 29.2307 19.4194 27.8268 22.1254C26.4229 24.8314 24.1338 26.9743 21.3411 28.1968C18.5485 29.4193 15.4212 29.6474 12.4807 28.8432C9.54015 28.039 6.96423 26.2511 5.18244 23.7775C3.40065 21.3039 2.52072 18.2943 2.68937 15.2504C2.85802 12.2066 4.06506 9.31262 6.10921 7.05103C8.15335 4.78945 10.911 3.297 13.9224 2.82257C16.9337 2.34814 20.0167 2.9204 22.6572 4.44393",
    stroke: "#008236",
    strokeWidth: 2.66552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9951 14.6594L15.9934 18.6577L29.321 5.33008",
    stroke: "#008236",
    strokeWidth: 2.66552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick3);
export default __webpack_public_path__ + "static/media/green_tick_3.083ae4ee22adb09ca993c44ca4503061.svg";
export { ForwardRef as ReactComponent };